/*
 * @Author: leventlei
 * @Date: 2024-01-07 09:49:51
 * @LastEditTime: 2024-12-21 17:42:37
 * @LastEditors: huasheng-c 957461792@qq.com
 * @Description:内容区头部-右侧用户头像
 * @FilePath: \IOT4CMS\src\layouts\baseLayout\user\index.tsx
 */
import React, { FC } from 'react'

import { GlobalModelState, LoginModelState } from '@/models/connect'
import { DownOutlined, LogoutOutlined } from '@ant-design/icons'
import { Avatar, Dropdown, MenuProps } from 'antd'
import { connect, Dispatch, Loading } from 'umi'

import './index.less'

export interface BasicLayoutProps {
	dispatch: Dispatch
	global: GlobalModelState
	loading: boolean
}
const role: any = {
	super_administrator: '超级管理员',
	platform_operation: '平台运营',
	ordinary_tourists: '普通游客',
}

const UserContent: FC<BasicLayoutProps> = ({ global, dispatch }) => {
	let uInfo: any = localStorage.getItem('userInfo')
	const items: MenuProps['items'] = [
		{
			label: '退出登录',
			key: 'logout',
			icon: <LogoutOutlined />,
		},
	]
	const handleMenuClick: MenuProps['onClick'] = e => {
		switch (e.key) {
			case 'logout':
				sessionStorage.removeItem('_projectId')
				dispatch({
					type: 'login/logout',
				})
				break
			default:
				break
		}
	}

	const menuProps: MenuProps = {
		items,
		onClick: handleMenuClick,
	}
	return (
		<div className="user">
			<Dropdown
				menu={menuProps}
				placement="bottom"
				arrow={{ pointAtCenter: true }}
			>
				<div className="userBox">
					<Avatar
						style={{
							color: '#000000',
							backgroundColor: '#ffffff',
							fontSize: '14px',
						}}
						size={24}
					>
						{JSON.parse(uInfo)?.nickName?.substring(0, 1) ||
							global.userInfo?.nickName?.substring(0, 1) ||
							'普'}
					</Avatar>
					<div className="userName">
						{JSON.parse(uInfo)?.nickName || global.userInfo?.nickName || '普'}
					</div>
				</div>
			</Dropdown>
		</div>
	)
}

export default connect(
	({
		login,
		loading,
		global,
	}: {
		login: LoginModelState
		loading: Loading
		global: GlobalModelState
	}) => ({ login, loading: loading.models.index, global }),
)(UserContent)
